import { Component, Input } from '@angular/core';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { BaseControlComponent } from './base-control.component';

@Component({
    selector: 'app-container-control',
    template: `
    <mat-label [ngClass]="{ boldLabel: isLabelBold }">{{ label | translation: translationRequest }}</mat-label>
    <div class="radio-container">
      <ng-content></ng-content>
      <mat-hint class="hint">{{ hintLabel | translation: translationRequest }}</mat-hint>
      @if (
        (formControl.dirty || formControl.touched) && formControl.invalid
        ) {
        <mat-error
          >{{ errorMessage | translation: translationRequest }}</mat-error
          >
        }
      </div>
    `,
    styles: [
        `
      .hint {
        font-size: 11px;
      }
      .radio-container {
        color: var(--sed-engaged-black-color);
        border-color:var(--sed-engaged-black-color);
      }
      .radio-container:focus {
        color: #171c20;
        border-color: #007dbc;
      }
      .boldLabel {
        font-weight: 600;
      }
    `,
    ],
    standalone: false
})
export class ContainerControlComponent extends BaseControlComponent {
  ngOnInit(): void {}

  @Input()
  isLabelBold: boolean = false;
  
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
}
